export const PREBOOK_ADD_ITEM = "PREBOOK_ADD_ITEM";
export const CART_SAVE_SHIPPING_ADDRESS = "PREBOOK_SAVE_SHIPPING_ADDRESS";
export const CART_RESET = "PREBOOK_RESET";
